import React from 'react';
import { ReactComponent as LogoIcon } from '@/assets/icons/LogoIcon.svg';
import { ReactComponent as LogoWithLabelIcon } from '@/assets/icons/LogoWithLabelIcon.svg';
import { ReactComponent as LanguageIcon } from '@/assets/icons/LanguageIcon.svg';
import { ReactComponent as DropdownArrowIcon } from '@/assets/icons/DropdownArrowIcon.svg';
import { ReactComponent as PasswordCheckIcon } from '@/assets/icons/PasswordCheckIcon.svg';
import { ReactComponent as PasswordCheckNoIcon } from '@/assets/icons/PasswordCheckNoIcon.svg';
import { ReactComponent as SearchIcon } from '@/assets/icons/SearchIcon.svg';
import { ReactComponent as UserIcon } from '@/assets/icons/UserIcon.svg';
import { ReactComponent as NotificationsIcon } from '@/assets/icons/NotificationsIcon.svg';
import { ReactComponent as CapsIcon } from '@/assets/icons/CapsIcon.svg';
import { ReactComponent as ChatIcon } from '@/assets/icons/ChatIcon.svg';
import { ReactComponent as StarIcon } from '@/assets/icons/StarIcon.svg';
import { ReactComponent as ProfileIcon } from '@/assets/icons/ProfileIcon.svg';
import { ReactComponent as SecurityIcon } from '@/assets/icons/SecurityIcon.svg';
import { ReactComponent as PrivacyIcon } from '@/assets/icons/PrivacyIcon.svg';
import { ReactComponent as BillingIcon } from '@/assets/icons/BillingIcon.svg';
import { ReactComponent as LogoutIcon } from '@/assets/icons/LogoutIcon.svg';
import { ReactComponent as CopyIcon } from '@/assets/icons/CopyIcon.svg';
import { ReactComponent as ExternalLinkIcon } from '@/assets/icons/ExternalLinkIcon.svg';
import { ReactComponent as QRIcon } from '@/assets/icons/QRIcon.svg';
import { ReactComponent as LocationIcon } from '@/assets/icons/LocationIcon.svg';
import { ReactComponent as PlantIcon } from '@/assets/icons/PlantIcon.svg';
import { ReactComponent as PlusIcon } from '@/assets/icons/PlusIcon.svg';
import { ReactComponent as CrossIcon } from '@/assets/icons/CrossIcon.svg';
import { ReactComponent as CheckmarkIcon } from '@/assets/icons/CheckmarkIcon.svg';
import { ReactComponent as AccordionArrowIcon } from '@/assets/icons/AccordionArrowIcon.svg';
import { ReactComponent as CapsFillIcon } from '@/assets/icons/CapsFillIcon.svg';
import { ReactComponent as LinkIcon } from '@/assets/icons/LinkIcon.svg';
import { ReactComponent as PlayIcon } from '@/assets/icons/PlayIcon.svg';
import { ReactComponent as PauseIcon } from '@/assets/icons/PauseIcon.svg';
import { ReactComponent as ThreePointsIcon } from '@/assets/icons/ThreePointsIcon.svg';
import { ReactComponent as ExpandIcon } from '@/assets/icons/ExpandIcon.svg';
import { ReactComponent as ReduceIcon } from '@/assets/icons/ReduceIcon.svg';
import { ReactComponent as InfiniteIcon } from '@/assets/icons/InfiniteIcon.svg';
import { ReactComponent as BackArrowIcon } from '@/assets/icons/BackArrowIcon.svg';
import { ReactComponent as PreviewIcon } from '@/assets/icons/PreviewIcon.svg';
import { ReactComponent as UploadIcon } from '@/assets/icons/UploadIcon.svg';
import { ReactComponent as OpenedEyeIcon } from '@/assets/icons/OpenedEyeIcon.svg';
import { ReactComponent as TrashIcon } from '@/assets/icons/TrashIcon.svg';
import { ReactComponent as CalendarIcon } from '@/assets/icons/CalendarIcon.svg';
import { ReactComponent as ArrowLeftIcon } from '@/assets/icons/ArrowLeftIcon.svg';
import { ReactComponent as ArrowRightIcon } from '@/assets/icons/ArrowRightIcon.svg';
import { ReactComponent as ArrowUpIcon } from '@/assets/icons/ArrowUpIcon.svg';
import { ReactComponent as ArrowDownIcon } from '@/assets/icons/ArrowDownIcon.svg';
import { ReactComponent as MockIcon } from '@/assets/icons/MockIcon.svg';
import { ReactComponent as BurgerIcon } from '@/assets/icons/BurgerIcon.svg';
import { ReactComponent as NoChosenIcon } from '@/assets/icons/NoChosenIcon.svg';
import { ReactComponent as LogoSign } from '@/assets/icons/LogoSign.svg';
import { ReactComponent as IncrementArrowIcon } from '@/assets/icons/IncrementArrowIcon.svg';
import { ReactComponent as DecrementArrowIcon } from '@/assets/icons/DecrementArrowIcon.svg';
import { ReactComponent as SendIcon } from '@/assets/icons/SendIcon.svg';
import { ReactComponent as SendFilledIcon } from '@/assets/icons/SendFilledIcon.svg';
import { ReactComponent as DescriptionIcon } from '@/assets/icons/DescriptionIcon.svg';
import { ReactComponent as InfoIcon } from '@/assets/icons/InfoIcon.svg';
/* Plant Stages Icons */
import { ReactComponent as TreePlantingStage1Icon } from '@/assets/icons/TreePlantingStage1Icon.svg';
import { ReactComponent as TreePlantingStage2Icon } from '@/assets/icons/TreePlantingStage2Icon.svg';
import { ReactComponent as TreePlantingStage3Icon } from '@/assets/icons/TreePlantingStage3Icon.svg';
import { ReactComponent as TreePlantingStage4Icon } from '@/assets/icons/TreePlantingStage4Icon.svg';
/* A_SocialIcons */
import { ReactComponent as GoogleIcon } from '@/assets/icons/A_SocialIcons/GoogleIcon.svg';
import { ReactComponent as FacebookIcon } from '@/assets/icons/A_SocialIcons/FacebookIcon.svg';
import { ReactComponent as AppleIcon } from '@/assets/icons/A_SocialIcons/AppleIcon.svg';
/* Q_SocialIcons */
import { ReactComponent as SocialGoogleIcon } from '@/assets/icons/Q_SocialIcons/SocialGoogleIcon.svg';
import { ReactComponent as SocialFacebookIcon } from '@/assets/icons/Q_SocialIcons/SocialFacebookIcon.svg';
import { ReactComponent as SocialAppleIcon } from '@/assets/icons/Q_SocialIcons/SocialAppleIcon.svg';
import { ReactComponent as SocialSnapchatIcon } from '@/assets/icons/Q_SocialIcons/SocialSnapchatIcon.svg';
import { ReactComponent as SocialPinterestIcon } from '@/assets/icons/Q_SocialIcons/SocialPinterestIcon.svg';
import { ReactComponent as SocialTikTokIcon } from '@/assets/icons/Q_SocialIcons/SocialTikTokIcon.svg';
import { ReactComponent as SocialYoutubeIcon } from '@/assets/icons/Q_SocialIcons/SocialYoutubeIcon.svg';
import { ReactComponent as SocialInstagramIcon } from '@/assets/icons/Q_SocialIcons/SocialInstagramIcon.svg';
import { ReactComponent as SocialLinkedInIcon } from '@/assets/icons/Q_SocialIcons/SocialLinkedInIcon.svg';
import { ReactComponent as SocialTelegramIcon } from '@/assets/icons/Q_SocialIcons/SocialTelegramIcon.svg';
import { ReactComponent as SocialDiscordIcon } from '@/assets/icons/Q_SocialIcons/SocialDiscordIcon.svg';
import { ReactComponent as SocialTwitchIcon } from '@/assets/icons/Q_SocialIcons/SocialTwitchIcon.svg';
import { ReactComponent as SocialVKIcon } from '@/assets/icons/Q_SocialIcons/SocialVKIcon.svg';
import { ReactComponent as SocialOKIcon } from '@/assets/icons/Q_SocialIcons/SocialOKIcon.svg';
import { ReactComponent as SocialTwitterIcon } from '@/assets/icons/Q_SocialIcons/SocialTwitterIcon.svg';
import { ReactComponent as SocialWhatsAppIcon } from '@/assets/icons/Q_SocialIcons/SocialWhatsAppIcon.svg';
import { ReactComponent as SocialDribbbleIcon } from '@/assets/icons/Q_SocialIcons/SocialDribbbleIcon.svg';
import { ReactComponent as SocialDzenIcon } from '@/assets/icons/Q_SocialIcons/SocialDzenIcon.svg';
import { ReactComponent as SocialRedditIcon } from '@/assets/icons/Q_SocialIcons/SocialRedditIcon.svg';
import { ReactComponent as SocialFigmaIcon } from '@/assets/icons/Q_SocialIcons/SocialFigmaIcon.svg';
import { ReactComponent as SocialGithubIcon } from '@/assets/icons/Q_SocialIcons/SocialGithubIcon.svg';
import { ReactComponent as SocialMediumIcon } from '@/assets/icons/Q_SocialIcons/SocialMediumIcon.svg';
import { ReactComponent as SocialNotionIcon } from '@/assets/icons/Q_SocialIcons/SocialNotionIcon.svg';
import { ReactComponent as SocialSpotifyIcon } from '@/assets/icons/Q_SocialIcons/SocialSpotifyIcon.svg';
import { ReactComponent as SocialThreadsIcon } from '@/assets/icons/Q_SocialIcons/SocialThreadsIcon.svg';
import { ReactComponent as SocialOtherIcon } from '@/assets/icons/Q_SocialIcons/SocialOtherIcon.svg';
/* PaySystems Icons */
import { ReactComponent as MirIcon } from '@/assets/icons/Q_PaySystemsIcons/MirIcon.svg';
import { ReactComponent as MasterCardIcon } from '@/assets/icons/Q_PaySystemsIcons/MasterCardIcon.svg';
import { ReactComponent as VisaIcon } from '@/assets/icons/Q_PaySystemsIcons/VisaIcon.svg';
/* Indicators Icons */
import { ReactComponent as PlantIndicatorIcon } from '@/assets/icons/PlantIndicatorIcon.svg';
import { ReactComponent as CommentIndicatorIcon } from '@/assets/icons/CommentIndicatorIcon.svg';
import { ReactComponent as Q_IndicatorErrorIcon } from '@/assets/icons/Q_IndicatorsIcons/Q_IndicatorErrorIcon.svg';
import { ReactComponent as Q_IndicatorSuccessIcon } from '@/assets/icons/Q_IndicatorsIcons/Q_IndicatorSuccessIcon.svg';
import { ReactComponent as ResendIcon } from '@/assets/icons/ResendIcon.svg';
import { ReactComponent as DeleteIcon } from '@/assets/icons/DeleteIcon.svg';

interface IconProps {
  icon: React.ComponentType<React.SVGProps<SVGSVGElement>>;
  width?: number | string;
  height?: number | string;
  fill?: string;
  stroke?: string;
}

const IconWrapper = ({
  icon: Icon,
  width,
  height,
  fill,
  stroke,
  ...props
}: IconProps) => {
  return (
    <Icon
      width={width}
      height={height}
      fill={fill}
      stroke={stroke}
      {...props}
    />
  );
};

export const Q_Icon = {
  LogoIcon: (props: Omit<IconProps, 'icon'>) => (
    <IconWrapper icon={LogoIcon} {...props} />
  ),
  LogoWithLabelIcon: (props: Omit<IconProps, 'icon'>) => (
    <IconWrapper icon={LogoWithLabelIcon} {...props} />
  ),
  LanguageIcon: (props: Omit<IconProps, 'icon'>) => (
    <IconWrapper icon={LanguageIcon} {...props} />
  ),
  DropdownArrowIcon: (props: Omit<IconProps, 'icon'>) => (
    <IconWrapper icon={DropdownArrowIcon} {...props} />
  ),
  PasswordCheckIcon: (props: Omit<IconProps, 'icon'>) => (
    <IconWrapper icon={PasswordCheckIcon} {...props} />
  ),
  PasswordCheckNoIcon: (props: Omit<IconProps, 'icon'>) => (
    <IconWrapper icon={PasswordCheckNoIcon} {...props} />
  ),
  SearchIcon: (props: Omit<IconProps, 'icon'>) => (
    <IconWrapper icon={SearchIcon} {...props} />
  ),
  UserIcon: (props: Omit<IconProps, 'icon'>) => (
    <IconWrapper icon={UserIcon} {...props} />
  ),
  NotificationsIcon: (props: Omit<IconProps, 'icon'>) => (
    <IconWrapper icon={NotificationsIcon} {...props} />
  ),
  CapsIcon: (props: Omit<IconProps, 'icon'>) => (
    <IconWrapper icon={CapsIcon} {...props} />
  ),
  ChatIcon: (props: Omit<IconProps, 'icon'>) => (
    <IconWrapper icon={ChatIcon} {...props} />
  ),
  CapsFillIcon: (props: Omit<IconProps, 'icon'>) => (
    <IconWrapper icon={CapsFillIcon} {...props} />
  ),
  StarIcon: (props: Omit<IconProps, 'icon'>) => (
    <IconWrapper icon={StarIcon} {...props} />
  ),
  ProfileIcon: (props: Omit<IconProps, 'icon'>) => (
    <IconWrapper icon={ProfileIcon} {...props} />
  ),
  SecurityIcon: (props: Omit<IconProps, 'icon'>) => (
    <IconWrapper icon={SecurityIcon} {...props} />
  ),
  PrivacyIcon: (props: Omit<IconProps, 'icon'>) => (
    <IconWrapper icon={PrivacyIcon} {...props} />
  ),
  BillingIcon: (props: Omit<IconProps, 'icon'>) => (
    <IconWrapper icon={BillingIcon} {...props} />
  ),
  LogoutIcon: (props: Omit<IconProps, 'icon'>) => (
    <IconWrapper icon={LogoutIcon} {...props} />
  ),
  CopyIcon: (props: Omit<IconProps, 'icon'>) => (
    <IconWrapper icon={CopyIcon} {...props} />
  ),
  LinkIcon: (props: Omit<IconProps, 'icon'>) => (
    <IconWrapper icon={LinkIcon} {...props} />
  ),
  ExternalLinkIcon: (props: Omit<IconProps, 'icon'>) => (
    <IconWrapper icon={ExternalLinkIcon} {...props} />
  ),
  PlayIcon: (props: Omit<IconProps, 'icon'>) => (
    <IconWrapper icon={PlayIcon} {...props} />
  ),
  PauseIcon: (props: Omit<IconProps, 'icon'>) => (
    <IconWrapper icon={PauseIcon} {...props} />
  ),
  PlusIcon: (props: Omit<IconProps, 'icon'>) => (
    <IconWrapper icon={PlusIcon} {...props} />
  ),
  CrossIcon: (props: Omit<IconProps, 'icon'>) => (
    <IconWrapper icon={CrossIcon} {...props} />
  ),
  BackArrowIcon: (props: Omit<IconProps, 'icon'>) => (
    <IconWrapper icon={BackArrowIcon} {...props} />
  ),
  PreviewIcon: (props: Omit<IconProps, 'icon'>) => (
    <IconWrapper icon={PreviewIcon} {...props} />
  ),
  UploadIcon: (props: Omit<IconProps, 'icon'>) => (
    <IconWrapper icon={UploadIcon} {...props} />
  ),
  CheckmarkIcon: (props: Omit<IconProps, 'icon'>) => (
    <IconWrapper icon={CheckmarkIcon} {...props} />
  ),
  ExpandIcon: (props: Omit<IconProps, 'icon'>) => (
    <IconWrapper icon={ExpandIcon} {...props} />
  ),
  ReduceIcon: (props: Omit<IconProps, 'icon'>) => (
    <IconWrapper icon={ReduceIcon} {...props} />
  ),
  AccordionArrowIcon: (props: Omit<IconProps, 'icon'>) => (
    <IconWrapper icon={AccordionArrowIcon} {...props} />
  ),
  OpenedEyeIcon: (props: Omit<IconProps, 'icon'>) => (
    <IconWrapper icon={OpenedEyeIcon} {...props} />
  ),
  TrashIcon: (props: Omit<IconProps, 'icon'>) => (
    <IconWrapper icon={TrashIcon} {...props} />
  ),
  QRIcon: (props: Omit<IconProps, 'icon'>) => (
    <IconWrapper icon={QRIcon} {...props} />
  ),
  LocationIcon: (props: Omit<IconProps, 'icon'>) => (
    <IconWrapper icon={LocationIcon} {...props} />
  ),
  PlantIcon: (props: Omit<IconProps, 'icon'>) => (
    <IconWrapper icon={PlantIcon} {...props} />
  ),
  BurgerIcon: (props: Omit<IconProps, 'icon'>) => (
    <IconWrapper icon={BurgerIcon} {...props} />
  ),
  NoChosenIcon: (props: Omit<IconProps, 'icon'>) => (
    <IconWrapper icon={NoChosenIcon} {...props} />
  ),
  LogoSign: (props: Omit<IconProps, 'icon'>) => (
    <IconWrapper icon={LogoSign} {...props} />
  ),
  InfiniteIcon: (props: Omit<IconProps, 'icon'>) => (
    <IconWrapper icon={InfiniteIcon} {...props} />
  ),
  ThreePointsIcon: (props: Omit<IconProps, 'icon'>) => (
    <IconWrapper icon={ThreePointsIcon} {...props} />
  ),
  TreePlantingStage1Icon: (props: Omit<IconProps, 'icon'>) => (
    <IconWrapper icon={TreePlantingStage1Icon} {...props} />
  ),
  TreePlantingStage2Icon: (props: Omit<IconProps, 'icon'>) => (
    <IconWrapper icon={TreePlantingStage2Icon} {...props} />
  ),
  TreePlantingStage3Icon: (props: Omit<IconProps, 'icon'>) => (
    <IconWrapper icon={TreePlantingStage3Icon} {...props} />
  ),
  TreePlantingStage4Icon: (props: Omit<IconProps, 'icon'>) => (
    <IconWrapper icon={TreePlantingStage4Icon} {...props} />
  ),
  MockIcon: (props: Omit<IconProps, 'icon'>) => (
    <IconWrapper icon={MockIcon} {...props} />
  ),
  GoogleIcon: (props: Omit<IconProps, 'icon'>) => (
    <IconWrapper icon={GoogleIcon} {...props} />
  ),
  FacebookIcon: (props: Omit<IconProps, 'icon'>) => (
    <IconWrapper icon={FacebookIcon} {...props} />
  ),
  AppleIcon: (props: Omit<IconProps, 'icon'>) => (
    <IconWrapper icon={AppleIcon} {...props} />
  ),
  SocialGoogleIcon: (props: Omit<IconProps, 'icon'>) => (
    <IconWrapper icon={SocialGoogleIcon} {...props} />
  ),
  SocialFacebookIcon: (props: Omit<IconProps, 'icon'>) => (
    <IconWrapper icon={SocialFacebookIcon} {...props} />
  ),
  SocialAppleIcon: (props: Omit<IconProps, 'icon'>) => (
    <IconWrapper icon={SocialAppleIcon} {...props} />
  ),
  SocialSnapchatIcon: (props: Omit<IconProps, 'icon'>) => (
    <IconWrapper icon={SocialSnapchatIcon} {...props} />
  ),
  SocialPinterestIcon: (props: Omit<IconProps, 'icon'>) => (
    <IconWrapper icon={SocialPinterestIcon} {...props} />
  ),
  SocialTikTokIcon: (props: Omit<IconProps, 'icon'>) => (
    <IconWrapper icon={SocialTikTokIcon} {...props} />
  ),
  SocialYoutubeIcon: (props: Omit<IconProps, 'icon'>) => (
    <IconWrapper icon={SocialYoutubeIcon} {...props} />
  ),
  SocialInstagramIcon: (props: Omit<IconProps, 'icon'>) => (
    <IconWrapper icon={SocialInstagramIcon} {...props} />
  ),
  SocialLinkedInIcon: (props: Omit<IconProps, 'icon'>) => (
    <IconWrapper icon={SocialLinkedInIcon} {...props} />
  ),
  SocialTelegramIcon: (props: Omit<IconProps, 'icon'>) => (
    <IconWrapper icon={SocialTelegramIcon} {...props} />
  ),
  SocialDiscordIcon: (props: Omit<IconProps, 'icon'>) => (
    <IconWrapper icon={SocialDiscordIcon} {...props} />
  ),
  SocialTwitchIcon: (props: Omit<IconProps, 'icon'>) => (
    <IconWrapper icon={SocialTwitchIcon} {...props} />
  ),
  SocialVKIcon: (props: Omit<IconProps, 'icon'>) => (
    <IconWrapper icon={SocialVKIcon} {...props} />
  ),
  SocialOKIcon: (props: Omit<IconProps, 'icon'>) => (
    <IconWrapper icon={SocialOKIcon} {...props} />
  ),
  SocialTwitterIcon: (props: Omit<IconProps, 'icon'>) => (
    <IconWrapper icon={SocialTwitterIcon} {...props} />
  ),
  SocialWhatsAppIcon: (props: Omit<IconProps, 'icon'>) => (
    <IconWrapper icon={SocialWhatsAppIcon} {...props} />
  ),
  SocialDribbbleIcon: (props: Omit<IconProps, 'icon'>) => (
    <IconWrapper icon={SocialDribbbleIcon} {...props} />
  ),
  SocialDzenIcon: (props: Omit<IconProps, 'icon'>) => (
    <IconWrapper icon={SocialDzenIcon} {...props} />
  ),
  SocialRedditIcon: (props: Omit<IconProps, 'icon'>) => (
    <IconWrapper icon={SocialRedditIcon} {...props} />
  ),
  SocialFigmaIcon: (props: Omit<IconProps, 'icon'>) => (
    <IconWrapper icon={SocialFigmaIcon} {...props} />
  ),
  SocialGithubIcon: (props: Omit<IconProps, 'icon'>) => (
    <IconWrapper icon={SocialGithubIcon} {...props} />
  ),
  SocialMediumIcon: (props: Omit<IconProps, 'icon'>) => (
    <IconWrapper icon={SocialMediumIcon} {...props} />
  ),
  SocialNotionIcon: (props: Omit<IconProps, 'icon'>) => (
    <IconWrapper icon={SocialNotionIcon} {...props} />
  ),
  SocialSpotifyIcon: (props: Omit<IconProps, 'icon'>) => (
    <IconWrapper icon={SocialSpotifyIcon} {...props} />
  ),
  SocialThreadsIcon: (props: Omit<IconProps, 'icon'>) => (
    <IconWrapper icon={SocialThreadsIcon} {...props} />
  ),
  SocialOtherIcon: (props: Omit<IconProps, 'icon'>) => (
    <IconWrapper icon={SocialOtherIcon} {...props} />
  ),
  MirIcon: (props: Omit<IconProps, 'icon'>) => (
    <IconWrapper icon={MirIcon} {...props} />
  ),
  MasterCardIcon: (props: Omit<IconProps, 'icon'>) => (
    <IconWrapper icon={MasterCardIcon} {...props} />
  ),
  VisaIcon: (props: Omit<IconProps, 'icon'>) => (
    <IconWrapper icon={VisaIcon} {...props} />
  ),
  IncrementArrowIcon: (props: Omit<IconProps, 'icon'>) => (
    <IconWrapper icon={IncrementArrowIcon} {...props} />
  ),
  DecrementArrowIcon: (props: Omit<IconProps, 'icon'>) => (
    <IconWrapper icon={DecrementArrowIcon} {...props} />
  ),
  PlantIndicatorIcon: (props: Omit<IconProps, 'icon'>) => (
    <IconWrapper icon={PlantIndicatorIcon} {...props} />
  ),
  CommentIndicatorIcon: (props: Omit<IconProps, 'icon'>) => (
    <IconWrapper icon={CommentIndicatorIcon} {...props} />
  ),
  CalendarIcon: (props: Omit<IconProps, 'icon'>) => (
    <IconWrapper icon={CalendarIcon} {...props} />
  ),
  ArrowLeftIcon: (props: Omit<IconProps, 'icon'>) => (
    <IconWrapper icon={ArrowLeftIcon} {...props} />
  ),
  ArrowRightIcon: (props: Omit<IconProps, 'icon'>) => (
    <IconWrapper icon={ArrowRightIcon} {...props} />
  ),
  ArrowUpIcon: (props: Omit<IconProps, 'icon'>) => (
    <IconWrapper icon={ArrowUpIcon} {...props} />
  ),
  ArrowDownIcon: (props: Omit<IconProps, 'icon'>) => (
    <IconWrapper icon={ArrowDownIcon} {...props} />
  ),
  SendIcon: (props: Omit<IconProps, 'icon'>) => (
    <IconWrapper icon={SendIcon} {...props} />
  ),
  SendFilledIcon: (props: Omit<IconProps, 'icon'>) => (
    <IconWrapper icon={SendFilledIcon} {...props} />
  ),
  DescriptionIcon: (props: Omit<IconProps, 'icon'>) => (
    <IconWrapper icon={DescriptionIcon} {...props} />
  ),
  InfoIcon: (props: Omit<IconProps, 'icon'>) => (
    <IconWrapper icon={InfoIcon} {...props} />
  ),
  Q_IndicatorErrorIcon: (props: Omit<IconProps, 'icon'>) => (
    <IconWrapper icon={Q_IndicatorErrorIcon} {...props} />
  ),
  Q_IndicatorSuccessIcon: (props: Omit<IconProps, 'icon'>) => (
    <IconWrapper icon={Q_IndicatorSuccessIcon} {...props} />
  ),
  ResendIcon: (props: Omit<IconProps, 'icon'>) => (
    <IconWrapper icon={ResendIcon} {...props} />
  ),
  DeleteIcon: (props: Omit<IconProps, 'icon'>) => (
    <IconWrapper icon={DeleteIcon} {...props} />
  ),
};
